class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
   this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));


    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);

    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        // console.log(";ladjalkjdlaldhkjahdjkasjkdj",html)
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
     // console.log(">>>>>>>>============================",html)
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  renderSwatches(){

  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    $('#SortBy').selectbox();
    $('body .sbHolder ul li').each(function(){
      $(this).on('click', function(){
       /* console.log('rel from facets',$(this).find('a').attr('rel'));
        var filterAttr = $(this).find('a').attr('rel');
        // $('body select#SortBy option[value='+filterAttr+']').trigger("click");
        //  $('body select#SortBy option[value='+filterAttr+']').attr('selected','selected');
        // $('body select#SortBy option:nth-child(2)').trigger("click");


        console.log('url', window.location.href);
        var filterURL = window.location.href;
        var lastParam = filterURL.split('&').pop();
        console.log('lastparam', lastParam);
       // window.location.href = filterURL.replace(lastParam,"sort_by="+filterAttr);
        console.log('replace',filterURL.replace(lastParam,"sort_by="+filterAttr));
        console.log('filterURL',filterURL);
       // $('select#SortBy[name="sort_by"]  option').removeAttr('selected')

       // $('select#SortBy').find('option[value='+filterAttr+']').attr("selected", "selected");

        if(filterURL.includes('filter')){
          console.log('contains filter')
          window.location.href = filterURL.replace(lastParam,"sort_by="+filterAttr);
          $('select#SortBy[name="sort_by"]  option').removeAttr('selected')

          $('select#SortBy').find('option[value='+filterAttr+']').attr("selected", "selected");
        }*/

      //  console.log('rel from theme ',$(this).find('a').attr('rel'));
        var filterAttr = $(this).find('a').attr('rel');
       // $('.sbHolder .sbSelector').empty().text(filterAttr);
        var filterURL = window.location.href;
        var lastParam = filterURL.split('&').pop();
        var firstParam = filterURL.split('?').pop();
        // $('body select#SortBy option[value='+filterAttr+']').trigger("click");
        //  $('body select#SortBy option[value='+filterAttr+']').attr('selected','selected');
        // $('body select#SortBy option:nth-child(2)').trigger("click");

     //   console.log('url', window.location.search);
        $('select#SortBy[name="sort_by"]  option').removeAttr('selected')

        $('select#SortBy').find('option[value='+filterAttr+']').attr("selected", "selected");
        //window.location.href = filterURL.replace(lastParam,"sort_by="+filterAttr);


        if(filterURL.includes('search')){

          if(filterURL.includes('filter')){
          //  console.log('contains filter')
            window.location.href = filterURL.replace(lastParam,"sort_by="+filterAttr);
            $('select#SortBy[name="sort_by"]  option').removeAttr('selected')

            $('select#SortBy').find('option[value='+filterAttr+']').attr("selected", "selected");
          }
          else{
            if (window.location.href.includes('sort_by')){
              window.location.href = filterURL.replace(firstParam,"sort_by="+filterAttr);
            }
            else{
              window.location.href = filterURL+"?sort_by="+filterAttr;
            }
          }




        }
        else{
          if(filterURL.includes('filter')){
           // console.log('contains filter')
            window.location.href = filterURL.replace(lastParam,"sort_by="+filterAttr);
            $('select#SortBy[name="sort_by"]  option').removeAttr('selected')

            $('select#SortBy').find('option[value='+filterAttr+']').attr("selected", "selected");
          }
          else{
            if (window.location.href.includes('?')){
              window.location.href = filterURL.replace(firstParam,"sort_by="+filterAttr);
            }
            else{
              window.location.href = filterURL+"?sort_by="+filterAttr;
            }
          }
        }






        // $('#FacetFiltersForm').submit();
        // $('#FacetSortDrawerForm').submit();



        // $('body select#SortBy  option[value='+filterAttr+']')
        // $('body select#SortBy').find('option[value='+filterAttr+']').prop('selected','slected').trigger('change');
      })
    })

    $(filterCloned).find('summary .filter-label').empty().text("Colour");
    $('details[data-filtername="color"] summary .filter-label').empty().text("Colour");
    $('#FacetsWrapperDesktop details.disclosure-has-popup summary[aria-label*="Color"] div span').empty().text("Colour");

    $('.template-search #FacetFiltersForm #FacetsWrapperDesktop details.disclosure-has-popup summary[aria-label*="More"] div span').empty().text("Colour");

   // console.log('rendered');
    var STOREFRONT_ACCESS_TOKEN = 'f0706fa0096e25e990c2f92359cb4da3';
    var GRAPHQL_URL = 'https://debrasaustralia.myshopify.com/api/2022-10/graphql.json';
  //  console.log('graphql url', GRAPHQL_URL);
    $('#ProductGridContainer .collection #product-grid li').each(function(){

      // // console.log($(this).data('prodid'));
      var prodId = $(this).data('prodid');
      var prodTag = $(this).data('tag');
    //  console.log($(this));
    //  console.log(prodTag)
      var that = $(this);
      var productQuery = () => ` {
              products(query:"tag:'${prodTag}'", first:16) {
                 edges {
                    node {
                      id
                      title
                      tags
                      handle
                      images(first:20){
                      edges{
                          node{
                            src
                           }
                          }
                          }
                      options {
                        id
                        name
                        values
                      }
                      media(first:10){
                        edges{
                          node{
                            mediaContentType
                            previewImage{
                            src
                            url
                            originalSrc
                            }

                          }
                        }
                      }

                        variants(first: 250) {
                        edges {
                          node {
                            id
                            title
                            sku
                            availableForSale
                            quantityAvailable
                            barcode
                            selectedOptions {
                              name
                              value
                            }
                            requiresShipping
                            weight
                            price {
                              amount
                              currencyCode
                            }
                            image {
                              src
                            }
                            currentlyNotInStock
                          }
                        }
                    }
                    }
                  }
                }


  }`;

      var GRAPHQL_BODY = () => {
        return {
          'async': true,
          'crossDomain': true,
          'method': 'POST',
          'headers': {
            'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
            'Content-Type': 'application/graphql',
          },
          'body': productQuery()
        };
      }
      var FetchData = fetch(GRAPHQL_URL, GRAPHQL_BODY())
          .then((res) => res.json())
          .then((products) => {
            // console.log('productsNew', products);
            return products.data.products.edges;
          });
      FetchData.then(res => {
        // console.log('res', res);

        if(res.length > 0){

          // if(res.productTags.length > 1) {
          var swathContainer = $('<div class="swatch-container">');
          var prods = [];

          var getCurrentColor =''
          res.forEach((i, itemIndex)=>{
            var getItem = i.node;
            if(getItem.options.filter(t=>t.name=='Color').length>0){

              if(getItem.handle == "{{product.handle}}"){
                getCurrentColor = getItem.options.filter(t=>t.name=='Color')[0].values[0];
              }
            }
          });
          // // // console.log(getCurrentColor, 'sdfsdfsdfsdf');

          // getItem.options.filter(t=>t.name=='Color')[0].values[0] !=getCurrentColor
          res.forEach((i, itemIndex)=>{
            var getItem = i.node;

            var colorValue = ''
            var handle = getItem.handle;

            var findImg = getItem.images.edges.filter(t=>(t.node.src.indexOf('_swatch') > -1 || t.node.src.indexOf('_color') > -1));

            var img = findImg.length > 0 ? findImg[0].node.src : '';
            // console.log('getItem', getItem);
            if(getItem.options.filter(t=>t.name=='Color').length>0){
              colorValue = getItem.options.filter(t=>t.name=='Color')[0].values[0];
              if(getItem.title.split(" ").pop().indexOf(")") == -1){
                if(prods.length ==0){
                  var makeObj ={img:img,color:colorValue,url:handle, title:getItem.title, variants:getItem.variants, featuredImg:getItem.images.edges, id: getItem.id}
                  if(getCurrentColor == colorValue){
                    makeObj.current =true;
                  }
                  prods.push(makeObj)
                } else if(prods.filter(x=>x.color ==colorValue).length ==0){
                  var makeObj ={img:img,color:colorValue,url:handle, title:getItem.title,variants:getItem.variants, featuredImg:getItem.images.edges, id: getItem.id}
                  if(getCurrentColor == colorValue){
                    makeObj.current =true;
                  }
                  prods.push(makeObj)
                }
              }
            }

            //  // console.log('makeObj', makeObj);

          });
          var coll_title = $(that).data('collectiontitle'); //22D
          // console.log('prods', prods);
          prods.forEach(v=>{
            var variants = v.variants.edges;
            //    console.log('variants', variants);
            //  num = coll_title.match(/\d+/g)[0];
            // num[0] will be 21
            //  console.log('num',num);
            var letr =  coll_title.match(/[a-zA-Z]+/g);
            // console.log("dlkahsjdakjdjkadgiadbhkab",letr)
            // console.log('letter', letr[0]);
            /* will be foofo.Now both are separated, and you can make any string as you like. */
            variants.forEach(e => {
              //console.log('e.node', e.node);
              //  if(e.node.title.split(' ')[0] == coll_title){
              // console.log('variant id',e.node.id.split('/').pop())
              //  varID = e.node.id.split('/').pop();
              //  }
            })
          })

          if(prods.length > 0){

            var prepareHtml ='';
            prods.forEach(y=>{
              // console.log('y', y);
              // prepareHtml +=`<a data-prodids="${y.id.split('/').pop()}" data-swatchprodid="${y.id}" data-images='${JSON.stringify(y.featuredImg)}' title="${y.color}" data-image="${y.img}" data-swatchvariants='${JSON.stringify(y.variants.edges)}' data-href="${y.current ? '#' :`/products/${y.url}`}" data-prod-title="${y.title}" data-handle="${y.url}" class="swatch ${y.current ? 'swatch-selected' : ''} ${y.img =='' ? 'no-img':''}" data-color="${y.color}" data-featuredImages="${y.featuredImg[0] ? y.featuredImg[1].node.src : ''}" data-featuredImages2="${y.featuredImg[1] ? y.featuredImg[0].node.src : ''}"><label>${y.color}</label>${y.img !='' ? `<img src="${y.img}">` : ''}</a>`
              prepareHtml +=`<a data-prodids="${y.id.split('/').pop()}" data-swatchprodid="${y.id}" data-images='${JSON.stringify(y.featuredImg)}' title="${y.color}" data-image="${y.img}" data-swatchvariants='${JSON.stringify(y.variants.edges)}' data-href="${y.current ? '#' :`/products/${y.url}`}" data-prod-title="${y.title}" data-handle="${y.url}" class="swatch ${y.current ? 'swatch-selected' : ''} ${y.img =='' ? 'no-img':''}" data-color="${y.color}"  data-featuredImages="${y.img ? y.featuredImg[0] ? y.featuredImg[1].node.src : '': ''}" data-featuredImages2="${y.img ? y.featuredImg[1] ? y.featuredImg[1]?.node?.src : y.featuredImg[0]?.node?.src : ''}"><label>${y.color}</label>${y.img !='' ? `<img src="${y.img}">` : ''}</a>`

            });
            // // console.log('prepareHTML', $(prepareHtml));


            //
            $(this).find('.card-information .price__container').append($(this).find('.color-swatch').prepend(prepareHtml));
            $(this).find('.color-swatch').wrap('<div class="color-swatch-holder">');
          }
          if($(prepareHtml).length > 6){
            //   // console.log('y');
            $(this).find('.color-swatch span.more').css('display','flex');
          }
          $(this).find('.color-swatch a').each(function(){
            //// console.log('thissss', this);
            $(this).on('click', function(){
                // console.log("djhsakjdjsajkdjadjashdhdhasdhgashdghasgdhgajdghadhgasdhadsda")
              var swatchId = $(this).data('swatchprodid');
              var prodIds = $(this).data('prodids');
              var swatchVariants = $(this).data('swatchvariants');
              var swatchProdImages = $(this).data('images');
              var swatchHandle = $(this).data('handle');
              // console.log('swatch id', swatchId);
              // console.log('prodIds', prodIds);
              // console.log('swatchVariants', swatchVariants);
              // console.log('swatchProdImages', swatchProdImages);
              // console.log('swatchHandle', swatchHandle);





              var productMediaQuery = () => ` {

              	product(id:"${swatchId}") {
                  title
                   variants(first: 100) {
                    edges {
                      node {
                        id
                        title
                      }
                    }
                  }
                  media(first:15) {
                    edges {
                      node {
                        ... fieldsForMediaTypes
                      }
                    }
                  }
                }



  }

         fragment fieldsForMediaTypes on Media {
               ... on Video {
                  id
                  sources {
                    format
                    height
                    mimeType
                    url
                    width
                  }
               }
     }`


              var GRAPHQL_BODY1 = () => {
                return {
                  'async': true,
                  'crossDomain': true,
                  'method': 'POST',
                  'headers': {
                    'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
                    'Content-Type': 'application/graphql',
                  },
                  'body': productMediaQuery()
                };
              }
              var FetchData = fetch(GRAPHQL_URL, GRAPHQL_BODY1())
                  .then((res) => res.json())
                  .then((products) => {
                    //  console.log('productsNewww', products);
                    return [products.data.product.media.edges,products.data.product.variants.edges];
                  });

              var video_url = [];
              var selectedVariantId
              FetchData.then(res => {
                // console.log('res', res);
                res[0].forEach(i => {
                  //  // console.log('i', i.node.sources);
                  if(i.node.sources !== undefined ){
                    video_url.push(...i.node.sources);

                  }

                })

                res[1].forEach((item,itemIndex)=>{
                  if(item.node.title.split(' ')[0] == coll_title){

                    selectedVariantId = item.node.id.split("/").pop()
                  }
                })
                var video =  video_url.filter(video => {
                  if(video.format === 'mp4' && video.height === 720) {
                    // console.log('yes');
                    return video;
                  }
                })[0]

                if(video && video.url){
                  // console.log('swatchProdImages[0]?.node?.source', swatchProdImages[0].node.src);
                  // console.log('swatchProdImages[0]?.node?.source', swatchProdImages[0].node);
                  $(that).find('.card-wrapper .card .card__inner .card__media').empty();
                  const video_html = `<div class="media media--transparent media--hover-effect">
                          <img data-width="1500" srcset="${swatchProdImages[0]?.node?.src}" src="${swatchProdImages[0]?.node?.src}" sizes="(min-width: 1200px) calc((100vw - 200px) / 3) , (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="" class="motion-reduce" loading="lazy" width="1500" height="2040">
                        <video id="video0" width="100%" height="auto" autoplay="true" muted="muted" loop="">
                            <source src="${video.url}" type="video/mp4">
                        </video>
            </div>`
                  $(that).find('.card-wrapper .card .card__inner .card__media').append(video_html);
                }

                // console.log('video_url', video_url);
                // console.log('video', video);
              //  console.log('selected variant',selectedVariantId)
                if(selectedVariantId){
                  $(that).find('a.card-bottom-link').attr('href',$(this).data('href')+'?variant='+selectedVariantId);
                  $(that).find('.card__heading > a').attr('href',$(this).data('href')+'?variant='+selectedVariantId);
                } else {
                  $(that).find('a.card-bottom-link').attr('href',$(this).data('href'));
                  $(that).find('.card__heading > a').attr('href',$(this).data('href'));
                }

              })

              $(that).find('.card-wrapper .card .card__inner .card__media .media img:first-child').attr('srcset', $(this).data('featuredimages'))
              $(that).find('.card-wrapper .card .card__inner .card__media .media img:first-child').attr('src', $(this).data('featuredimages'))
              $(that).find('.card-wrapper .card .card__inner .card__media .media img:nth-child(2)').attr('srcset', $(this).data('featuredimages2'))
              $(that).find('.card-wrapper .card .card__inner .card__media .media img:nth-child(2)').attr('src', $(this).data('featuredimages2'))


              // swatchVariants.forEach(variant => {
              //   // console.log('variant.node', variant.node);
              //   if(variant.node.title.includes(num[0]) || variant.node.title.includes(coll_title)){
              //     // console.log('yes', variant.node.title);
              //     // console.log('yes id', variant.node.id);
              //     variantId = variant.node.id.split('/').pop();
              //     // console.log('yes variantId', variantId);
              //     // console.log('tttthis', this);
              //     // console.log("'$(this).data('href')+'?variant='+variantId'", $(this).data('href')+'?variant='+variantId);
              //
              //     $(that).find('a.card-bottom-link').attr('href',$(this).data('href')+'?variant='+variantId);
              //     $(that).find('.card__heading > a').attr('href',$(this).data('href')+'?variant='+variantId);
              //
              //   }
              //
              // })

            })
          })
        }
      })
    })

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;

    })
    $('body .mobile-facets__open .filter-count').empty();
    var filtersLength =  $('.active-facets-desktop facet-remove:not(.active-facets__button-wrapper)').length
    setTimeout(function(){
      if(filtersLength === 0){
        $('body .mobile-facets__open .filter-count').append('');
      }
      else{
        $('body .mobile-facets__open .filter-count').append('('+filtersLength+')');
      }


    },1000);
   // document.querySelector('.facets-container.facets-container-drawer').innetText = filtersLength;

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }


  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)

    }


  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change',(e) =>{
        e.preventDefault();
       // console.log('event');
        this.onRangeChange.bind(this)
      }));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
   // event.preventDefault();
   // console.log('price change');
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
   // console.log('this', this);
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });

  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
   // window.location.reload();
  }

}

customElements.define('facet-remove', FacetRemove);
